var render = function render(){
  var _vm$user, _vm$user2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "white--text",
    attrs: {
      "tile": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "pa-18px px-md-10px pa-lg-24px"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "font-size-18 font-size-md-20 font-weight-bold line-height-1"
  }, [_vm._v(_vm._s((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.name) + " 님")]), _c('div', {
    staticClass: "font-size-14 line-height-1 mt-8px"
  }, [_vm._v(_vm._s((_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2.username))])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }